module.exports = "Kevin Gichia\n============\n\nData Analysis\nBackend Developing\nData Mining\nMachine Learning \nNeural set training \n\nContact\n-------\n\n* Kevogich@gmail.com\n* pgp - key provided\n\nAvailability\n------------\n\nI am happy to entertain\nproposals for Projects\n\n\nRepositories\n--------\n\n* www.github.com/kevogich\n*\n\n\nTools and Skills\n----------------\n* Python\n* JSXHint\n* Bootstrap\n* SQL\n* Hadoop\n* R\n* react-draggable\n* Respective frameworks\n* backbone.queryRouter\n* Computer Networking (IP Adressing ,Routing)\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./work.txt
 ** module id = 90
 ** module chunks = 0 1
 **/